import jwtAuthAxios from "services/jwtAuth";
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

const withAuth = () => {
    const token = localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
};

// Generate tagihan dari tarif config. payload: { periode, semester, angkatan, backfill }
export const generateTagihan = createAsyncThunk("generateTagihan/generate", async (payload, { rejectWithValue }) => {
    try {
        withAuth();
        const response = await jwtAuthAxios.post(`v1/pembayaran/generate-tagihan`, payload);
        return response.data;
    } catch (err) {
        return rejectWithValue(err?.response?.data || { message: err.message });
    }
});

// Daftar tarif config yang sudah dikonfigurasi.
export const getTarifList = createAsyncThunk("generateTagihan/getTarifList", async () => {
    withAuth();
    const response = await jwtAuthAxios.get(`v1/tarif-pembayaran`);
    return response.data;
});

// Daftar periode (siakad.t_periode) untuk pilihan select. value = kode, label = nama.
export const getPeriodeList = createAsyncThunk("generateTagihan/getPeriodeList", async () => {
    withAuth();
    const response = await jwtAuthAxios.get(`v1/periode`);
    return response.data;
});

const initialState = {
    loading: false,
    result: null,
    loadingTarif: false,
    dataTarif: [],
    loadingPeriode: false,
    dataPeriode: [],
};

const generateTagihanSlice = createSlice({
    name: "generateTagihan",
    initialState,
    reducers: {
        resetResult: (state) => { state.result = null; },
    },
    extraReducers: (builder) => {
        builder
            .addCase(generateTagihan.pending, (state) => { state.loading = true; state.result = null; })
            .addCase(generateTagihan.fulfilled, (state, action) => {
                state.result = action.payload?.data || action.payload;
                state.loading = false;
            })
            .addCase(generateTagihan.rejected, (state) => { state.loading = false; });

        builder
            .addCase(getTarifList.pending, (state) => { state.loadingTarif = true; })
            .addCase(getTarifList.fulfilled, (state, action) => {
                state.dataTarif = Array.isArray(action.payload) ? action.payload : [];
                state.loadingTarif = false;
            })
            .addCase(getTarifList.rejected, (state) => { state.loadingTarif = false; });

        builder
            .addCase(getPeriodeList.pending, (state) => { state.loadingPeriode = true; })
            .addCase(getPeriodeList.fulfilled, (state, action) => {
                state.dataPeriode = Array.isArray(action.payload) ? action.payload : [];
                state.loadingPeriode = false;
            })
            .addCase(getPeriodeList.rejected, (state) => { state.loadingPeriode = false; });
    },
});

export const { resetResult } = generateTagihanSlice.actions;
export const generateTagihanSelector = (state) => state.generateTagihan;
export default generateTagihanSlice.reducer;
